import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import {
  setAllRowsReducer,
  setEditableCellReducer,
  updateRowReducer,
  updateBudgetReducer,
  updateTarpsReducer,
  updateImpactReducer,
  updateTotalCalculatedBudgetReducer,
  updateTotalCalculatedTarpsReducer,
  updateTotalCalculatedImpactsReducer
} from './burstReducer';

export const burstSlice = createSlice({
  name: 'burst',
  initialState,
  reducers: {
    updateRow: updateRowReducer,
    setAllRows: setAllRowsReducer,
    setEditableCell: setEditableCellReducer,
    updateBudget: updateBudgetReducer,
    updateTarps: updateTarpsReducer,
    updateImpact: updateImpactReducer,
    updateTotalCalculatedBudget: updateTotalCalculatedBudgetReducer,
    updateTotalCalculatedTarps: updateTotalCalculatedTarpsReducer,
    updateTotalCalculatedImpacts: updateTotalCalculatedImpactsReducer
  }
});

export const {
  updateRow,
  setAllRows,
  setEditableCell,
  updateBudget,
  updateTarps,
  updateImpact,
  updateTotalCalculatedBudget,
  updateTotalCalculatedTarps,
  updateTotalCalculatedImpacts
} = burstSlice.actions;

export default burstSlice.reducer;
